export enum InvoiceStatusType {
  INVOICED = 'INVOICED',
  CANCELED = 'CANCELED',
  REJECTED = 'REJECTED',
  DELETED = 'DELETED',
}
